document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".review-slider").forEach(function (slider) {
    new Splide(slider, {
      type: "slide",
      perPage: 3,
      gap: 20,
      arrows: false,
      drag: false,
      breakpoints: {
        1023: {
          gap: 15,
          arrows: true,
          drag: true,
          perPage: 2,
        },
        767: {
          gap: 10,
          arrows: true,
          drag: true,
          perPage: 1,
          padding: { left: "20px", right: "62px" },
        },
      },
    }).mount();
  });
  
  new Splide(".happycustomers-slider", {
    perPage: 3,
    gap: 20,
    arrows: true,
    mediaQuery: "max",
    breakpoints: {
      767: {
        destroy: true,
      },
      1023: {
        gap: 15,
        perPage: 2,
      },
    },
  }).mount();

  const deliveryDateSpans = document.querySelectorAll('[id^="delivery-date-"]');

  deliveryDateSpans.forEach(function (el) {
    const daysToAdd = parseInt(el.getAttribute("data-days"), 10) || 0;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + daysToAdd);

    const month = currentDate.toLocaleString("en-US", { month: "long" });
    const day = currentDate.getDate();
    const suffix = getOrdinalSuffix(day);

    el.textContent = `${month} ${day}${suffix}`;
  });

  function getOrdinalSuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  const accordionTitles = document.querySelectorAll(".accordion-question");

  accordionTitles.forEach((title) => {
    const content = title.nextElementSibling;
    content.style.height = "0";
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease";

    title.addEventListener("click", function () {
      accordionTitles.forEach((otherTitle) => {
        if (otherTitle !== this) {
          otherTitle.classList.remove("open");
          otherTitle.querySelector(".accordion-btn").textContent = "+";
          const otherContent = otherTitle.nextElementSibling;
          otherContent.style.height = "0";
        }
      });

      this.classList.toggle("open");
      const btn = this.querySelector(".accordion-btn");
      const isOpen = this.classList.contains("open");
      btn.textContent = isOpen ? "-" : "+";

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0";
      }
    });
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetID = this.getAttribute("href");
      const targetElement = document.querySelector(targetID);

      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop + 120, // Adjust for header if needed
          behavior: "smooth",
        });
      }
    });
  });
});
